import { Loader } from "@googlemaps/js-api-loader";

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

let loaderInstance: Loader | null = null;

export const getGoogleMapsLoader = () => {
    if (!loaderInstance) {
        loaderInstance = new Loader({
            apiKey: apiKey || "",
            version: "beta",
            language: "en",
            libraries: ["places"]
        });
    }
    return loaderInstance;
}; 